import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import React from 'react';

const ActionLinearProgress = ({ isActioning = false }) => {
    return (
        <div style={{ height: '4px', visibility: isActioning ? 'visible' : 'hidden' }}>
            {isActioning && <LinearProgress />}
        </div>
    );
};

ActionLinearProgress.propTypes = {
    isActioning: PropTypes.bool,
};

ActionLinearProgress.defaultProps = {
    isActioning: false,
};

export default ActionLinearProgress;
